import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import useApi from '../../hooks/useApi';
import EventToAdminBind from '../event/EventToAdminBind';
//
// Компонент выводит два списка:
// 1) Список привязанных к пользователю мероприятий
// 2) Список мероприятий, которые еще можно привязать
// Предполагается (но не проверяется) что отображаемый пользователь admin,
// а страницу смотрит root.
//
const AdminToEventList = ({ admin }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const role = useSelector(state => state.auth.user.role);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ admin: admin._id });
	const [ binds, errorBinds, isLoadingBinds ] = useApi({ type: 'get', method: '/a2e', params });
	const [ events, errorEvents, isLoadingEvents ] = useApi({ type: 'get', method: '/events', params });
    const [ bindsTo, setBindsTo ] = useState(null);

    // Убираем из второго списка тех, кто уже есть в первом
    useEffect(() => {
        if(!binds || !events) return;
        for(let i = 0; i < binds.a2e.length; i ++) {
            let event_id = binds.a2e[i].event._id;
            let index = events.events.findIndex(event => event._id === event_id);
            if(index >= 0) {
                events.events.splice(index, 1);
            }
        }
        setBindsTo(events.events);
    }, [binds, events]);
/*
    TODO: Эта функция будет нужна, когда поймем как вызывать из <UserToEventBind>
    обновление родителя (чтобы сразу отобразить новые списки). Пока не ясно как
    сделать вызов после того, как изменение привязки произошло на сервере. Часто
    вызов обновления проходит раньше, чем изменения произошли.
    const update = () => {
        // Для форсирования повторного запроса АПИ
        // мы делаем вид что поменяли параметры запроса.
        setParams({ admin: user._id });
    };
*/
	return (
    <div>
        <h2>{t('a2e.binds')}</h2>
        {errorBinds && <div className='error'>{t(errorBinds)}</div>}
        {isLoadingBinds && <div>{t('loader.title')}</div>}
        {binds &&
        <React.Fragment>
            {binds.a2e.length ?
            <ul>
            {binds.a2e.map(item => (
                <li key={item._id}>
                    <NavLink to={'/cabinet/eventview/'+item.event._id}>{item.event.name[lang]}</NavLink>
                    <EventToAdminBind admin={admin._id} event={item.event._id} bind={false}/>
                </li>
            ))}
            </ul> : <div>{t('a2e.nobinds')}</div>}
        </React.Fragment>}

        {role === 'root' &&
        <React.Fragment>
            <h2>{t('a2e.bindto')}</h2>
            {errorEvents && <div className='error'>{t(errorEvents)}</div>}
            {isLoadingEvents && <div>{t('loader.title')}</div>}
            {bindsTo &&
            <React.Fragment>
                {bindsTo.length ?
                <ul>
                {bindsTo.map(item => (
                    <li key={item._id}>
                        <NavLink to={'/cabinet/eventview/'+item._id}>{item.name[lang]}</NavLink>
                        <EventToAdminBind admin={admin._id} event={item._id} bind={true}/>
                    </li>
                ))}
                </ul> : <div>{t('a2e.nobindto')}</div>}
            </React.Fragment>}
        </React.Fragment>}
    </div>
	);
};

AdminToEventList.propTypes = {
    admin: PropTypes.object.isRequired,
};

export default AdminToEventList;
